var swiper = Swiper;
var init = false;
function swiperMode() {
    let mobile = window.matchMedia("(min-width: 0px) and (max-width: 990px)");

    if (mobile.matches) {
        if (!init) {
            init = true;
            swiper = new Swiper(".benefits-section__slider", {
                slidesPerView: 2,
                spaceBetween: 16,
                pagination: {
                    el: ".benefits-section__slider-pagination",
                    clickable: true,
                },
            });
        }
    } else {
        swiper.destroy();
        init = false;
    }
}

window.addEventListener("load", function () {
    swiperMode();
});

window.addEventListener("resize", function () {
    swiperMode();
});